import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import StyledButton from './StyledButton';

export default class LargeLinkedButton extends Component {
    render() {
        return (
            <Link to={{
                pathname: this.props.buttonDestination,
                state: {
                    func: this.props.func,
                    detailSite: this.props.detailSite,
                    titel: this.props.titel,
                    showLastTargets: this.props.showLastTargets,
                    onlyStops: this.props.onlyStops
                }
            }}
            >
                <StyledButton className="large">{this.props.buttonLabel}</StyledButton>
            </Link>
        )
    }
}
